// ABOUTME: Shared utility for clearing all IndexedDB databases
// ABOUTME: Used by error boundary and error page for full app reset

export async function clearAllIndexedDB(): Promise<void> {
  // Timeout to prevent hanging if databases() is slow
  const timeoutMs = 3000

  let databases: IDBDatabaseInfo[] = []
  try {
    databases = await Promise.race([
      indexedDB.databases(),
      new Promise<IDBDatabaseInfo[]>((_, reject) => {
        setTimeout(() => reject(new Error("timeout")), timeoutMs)
      }),
    ])
  } catch {
    // If databases() fails or times out, skip IndexedDB clearing
    return
  }

  await Promise.all(
    databases.map((db) => {
      if (db.name) {
        return new Promise<void>((resolve) => {
          const request = indexedDB.deleteDatabase(db.name as string)
          // Resolve on success, blocked, or error - don't hang
          request.onsuccess = () => resolve()
          request.onerror = () => resolve()
          request.onblocked = () => resolve()
          // Safety timeout in case none of the events fire
          setTimeout(resolve, 1000)
        })
      }
      return Promise.resolve()
    }),
  )
}
